import HtmlElement from './HtmlElement';
import {$body} from '../Constants';

/**
 * Adds collapse / expand functionality to collapsible content
 */
class ResultsheetOverview extends HtmlElement {

	onReady() {
		this.$images = this.$element.find('.resultsheetImages li');
		this.$actions = this.$element.find('.resultsheetActions');
		this.$selectors = this.$element.find('.resultsheetNames li');

		let $firstSheet = this.$selectors.first();

		$firstSheet.addClass('act');
		this.onSelectorClick($firstSheet);

		this.$selectors.on('click', e => {
			this.onSelectorClick($(e.target));
		});
	}

	onSelectorClick($target) {
		let sheet = $target.data('sheet');

		this.$selectors.removeClass('act');
		$target.addClass('act');

		this.$images.add(this.$actions)
			.hide()
			.filter((index, element) => {
				return $(element).data('sheet') === sheet;
			})
			.show();
	}
}

export default (new ResultsheetOverview($body.find('.resultsheetOverview')));